import { render, staticRenderFns } from "./style-test-home.vue?vue&type=template&id=0cda4b9c&scoped=true&"
import script from "./style-test-home.vue?vue&type=script&lang=js&"
export * from "./style-test-home.vue?vue&type=script&lang=js&"
import style0 from "./style-test-home.vue?vue&type=style&index=0&id=0cda4b9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cda4b9c",
  null
  
)

export default component.exports